export function createDateString (dateString: string, locale: string): string {
    const date = new Date(dateString)
    const options: Intl.DateTimeFormatOptions = {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
    }

    return date.toLocaleString(locale, options)
}
